export const defaultSorted = [{dataField: "priority", order: "asc"}];
export const sizePerPageList = [
    { text: "15", value: 15 },
    { text: "30", value: 30 },
    { text: "50", value: 50 },
    { text: "100", value: 100 }
];
export const initialFilter = {
    filter: {
        vin: "",
        make: "",
        model: "",
        modelYear: ""
    },
    sortOrder: "asc", // asc||desc
    sortField: "id",
    pageNumber: 1,
    pageSize: 15
};